'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { motion } from 'motion/react';
import { useMemo } from 'react';
import type { HorizontalBudgetBarProps } from '@/modules/finances/types';
function HorizontalBudgetBar(t0) {
  const $ = _c(20);
  const {
    actuals,
    prediction,
    budgetCap,
    className,
    maxPercentage: t1
  } = t0;
  const maxPercentage = t1 === undefined ? 87 : t1;
  const maxValue = Math.max(actuals, prediction, budgetCap) || 1;
  const t2 = actuals / maxValue * maxPercentage;
  const t3 = prediction / maxValue * maxPercentage;
  const t4 = budgetCap / maxValue * maxPercentage;
  let t5;
  if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
    t5 = {
      actualsWidth: t2,
      predictionWidth: t3,
      budgetCapPosition: t4
    };
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const dimensions = t5;
  let t6;
  if ($[4] !== className) {
    t6 = cn("bg-muted relative h-4 w-full overflow-hidden rounded-lg", className);
    $[4] = className;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== dimensions || $[7] !== prediction) {
    t7 = prediction > 0 && <div data-slot="prediction-bar" data-type="prediction" className={cn("bg-chart-2 absolute top-0 left-0 h-full rounded-lg")} style={{
      width: `${dimensions.predictionWidth}%`
    }} />;
    $[6] = dimensions;
    $[7] = prediction;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== actuals || $[10] !== dimensions) {
    t8 = actuals > 0 && <motion.div data-slot="actuals-bar" data-type="actuals" className={cn("bg-status-success absolute top-0 left-0 h-full rounded-lg")} initial={{
      width: 0
    }} animate={{
      width: `${dimensions.actualsWidth}%`
    }} transition={{
      duration: 0.85,
      ease: "easeInOut"
    }} />;
    $[9] = actuals;
    $[10] = dimensions;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== budgetCap || $[13] !== dimensions) {
    t9 = budgetCap > 0 && <div data-slot="budget-cap-line" data-type="budget" className={cn("bg-destructive absolute top-0 h-full w-px")} style={{
      left: `${dimensions.budgetCapPosition}%`
    }} />;
    $[12] = budgetCap;
    $[13] = dimensions;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t6 || $[16] !== t7 || $[17] !== t8 || $[18] !== t9) {
    t10 = <div data-slot="budget-bar" className={t6}>{t7}{t8}{t9}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}
export { HorizontalBudgetBar };